import { NavLink as RouterNavLink } from "react-router-dom";
import { cn } from "../lib/utils";

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  activeClassName?: string;
  end?: boolean;
}

export const NavLink = ({
  to,
  children,
  className,
  activeClassName = "bg-sidebar-accent text-sidebar-primary font-medium",
  end = false,
}: NavLinkProps) => {
  return (
    <RouterNavLink
      to={to}
      end={end}
      className={({ isActive }) => cn(className, isActive && activeClassName)}
    >
      {children}
    </RouterNavLink>
  );
};
